var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-row',{attrs:{"gutter":50}},[_c('el-col',{attrs:{"span":12}},[_c('todo')],1),_c('el-col',{attrs:{"span":12}},[_c('notice')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }